<mat-card style="border-color: #5775a8;">

  <mat-card-header>
    <div class="flex flex-row rounded-lg w-full" style="background-color: #5775a8;align-items: center;">
      <div class="flex w-full" style="padding-left: 20px;">
        <span style="color: white;">
          Comments added here will be available to all complaints for this business:
          <!-- <b>{{currentBusiness.businessName}}</b> -->
        </span>
      </div>

      <div class="flex flex-col" style="padding-right: 20px;">
        <button mat-raised-button (click)="add()" class="m-8 container" style="background: #7ABDF3;">
          <mat-icon>add</mat-icon> Add
        </button>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>
      <div class="flex flex-col" style="overflow-x:auto">
        <div class="flex flex-row">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
            class="mat-elevation-z8">

            <ng-container matColumnDef="loggedDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
              <td mat-cell *matCellDef="let notes">{{notes.loggedDate}}</td>
            </ng-container>
            <ng-container matColumnDef="text">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
              <td mat-cell *matCellDef="let notes">{{notes.text}}</td>
            </ng-container>
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Entered By</th>
              <td mat-cell *matCellDef="let notes">{{notes.user}}</td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
          </table>
        </div>
        <!-- <mat-paginator [pageSizeOptions]="[5, 10]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator> -->
      </div>
    </mat-card>
    <br />

  </mat-card-content>

</mat-card>